export default {
    state: {
        offerPromotions: [],
        offers: [

            // {
            //     id: '345456',
            //     type: 'productOffer',
            //     usecase: 'takeAway',
            //     active: true,
            //
            //     name: 'Mittwoch Pizzatag',
            //     timeText: 'Jeden Mittwoch',
            //     offerText: 'Pizza 30 cm mit 3 Extras deiner Wahl',
            //     offerPrice: 5.5,
            //
            //     days: {
            //         '1': false,
            //         '2': false,
            //         '3': false,
            //         '4': false,
            //         '5': false,
            //         '6': false,
            //         '7': false,
            //     },
            //
            //     product:
            //         {
            //             "id": "auxp49870i6kd8jwixy6ej",
            //             "nameDE": "Romana",
            //             "nameEN": "",
            //             "descriptionEN": "",
            //             "descriptionDE": "Schinken, Artischocken",
            //             "extras": {
            //                 "variants": [
            //                     {
            //                         "optional": false,
            //                         "title": "Mit Welcher Beilage?",
            //                         "options": [
            //                             {
            //                                 "id": "st0i7yiz47djwjcwhj1",
            //                                 "labelDE": "Pommes und Beilagensalat",
            //                                 "labelEN": "",
            //                                 "cost": 0
            //                             },
            //                             {
            //                                 "id": "w0wasf6zfcjwjcwyq0",
            //                                 "labelDE": "Kroketten und Beilagensalat",
            //                                 "labelEN": "",
            //                                 "cost": 2.6
            //                             },
            //                             {
            //                                 "id": "5rusfpjx5qjjwjcx74n",
            //                                 "labelDE": "Nudeln ohne Beilagensalat",
            //                                 "labelEN": "",
            //                                 "cost": 0
            //                             }
            //                         ]
            //                     }
            //                 ],
            //                 "styles": [
            //                     {
            //                         "id": "es-8-1",
            //                         "labelDE": "Schinken",
            //                         "labelEN": "Schinken",
            //                         "cost": 0.7,
            //                         "bigCost": 1.5
            //                     },
            //                     {
            //                         "id": "es-8-2",
            //                         "labelDE": "Salami",
            //                         "labelEN": "Salami",
            //                         "cost": 0.7,
            //                         "bigCost": 1.5
            //                     },
            //                     {
            //                         "id": "es-8-3",
            //                         "labelDE": "Pilze",
            //                         "labelEN": "Pilze",
            //                         "cost": 0.7,
            //                         "bigCost": 1.5
            //                     },
            //                     {
            //                         "id": "es-8-4",
            //                         "labelDE": "Zwiebeln",
            //                         "labelEN": "Zwiebeln",
            //                         "cost": 0.7,
            //                         "bigCost": 1.5
            //                     },
            //                     {
            //                         "id": "es-8-5",
            //                         "labelDE": "Broccoli",
            //                         "labelEN": "Broccoli",
            //                         "cost": 0.7,
            //                         "bigCost": 1.5
            //                     },
            //                     {
            //                         "id": "es-8-6",
            //                         "labelDE": "Artischoken",
            //                         "labelEN": "Artischoken",
            //                         "cost": 0.7,
            //                         "bigCost": 1.5
            //                     },
            //                     {
            //                         "id": "es-8-7",
            //                         "labelDE": "Paprika",
            //                         "labelEN": "Paprika",
            //                         "cost": 0.7,
            //                         "bigCost": 1.5
            //                     },
            //                     {
            //                         "id": "es-8-8",
            //                         "labelDE": "Peperoni",
            //                         "labelEN": "Peperoni",
            //                         "cost": 0.7,
            //                         "bigCost": 1.5
            //                     },
            //                     {
            //                         "id": "es-8-9",
            //                         "labelDE": "Kapern",
            //                         "labelEN": "Kapern",
            //                         "cost": 0.7,
            //                         "bigCost": 1.5
            //                     },
            //                     {
            //                         "id": "es-8-10",
            //                         "labelDE": "Mais",
            //                         "labelEN": "Mais",
            //                         "cost": 0.7,
            //                         "bigCost": 1.5
            //                     },
            //                     {
            //                         "id": "es-8-11",
            //                         "labelDE": "Sardellen",
            //                         "labelEN": "Sardellen",
            //                         "cost": 0.7,
            //                         "bigCost": 1.5
            //                     },
            //                     {
            //                         "id": "es-8-35",
            //                         "labelDE": "Lachs",
            //                         "labelEN": "Lachs",
            //                         "cost": 2,
            //                         "bigCost": 3
            //                     },
            //                     {
            //                         "id": "es-8-36",
            //                         "labelDE": "Krabben",
            //                         "labelEN": "Krabben",
            //                         "cost": 2,
            //                         "bigCost": 3
            //                     },
            //                     {
            //                         "id": "es-8-37",
            //                         "labelDE": "Meeresfrüchte",
            //                         "labelEN": "Meeresfrüchte",
            //                         "cost": 2,
            //                         "bigCost": 3
            //                     },
            //                     {
            //                         "id": "es-8-38",
            //                         "labelDE": "Thunfisch",
            //                         "labelEN": "Thunfisch",
            //                         "cost": 2,
            //                         "bigCost": 3
            //                     },
            //                     {
            //                         "id": "es-8-43",
            //                         "labelDE": "Käse",
            //                         "labelEN": "Käse",
            //                         "cost": 1,
            //                         "bigCost": 2
            //                     },
            //                     {
            //                         "id": "es-8-44",
            //                         "labelDE": "Mozzarella",
            //                         "labelEN": "Mozzarella",
            //                         "cost": 1,
            //                         "bigCost": 2
            //                     },
            //                     {
            //                         "id": "es-8-45",
            //                         "labelDE": "Gorgonzola",
            //                         "labelEN": "Gorgonzola",
            //                         "cost": 1,
            //                         "bigCost": 2
            //                     },
            //                     {
            //                         "id": "es-8-46",
            //                         "labelDE": "Schafskäse",
            //                         "labelEN": "Schafskäse",
            //                         "cost": 1,
            //                         "bigCost": 2
            //                     },
            //                     {
            //                         "id": "es-8-47",
            //                         "labelDE": "Parmesan",
            //                         "labelEN": "Parmesan",
            //                         "cost": 1,
            //                         "bigCost": 2
            //                     }
            //                 ]
            //             },
            //             sizes: [
            //                 {
            //                     vol: "30 cm",
            //                     price: 6.7
            //                 },
            //                 {
            //                     vol: "40 cm",
            //                     price: 11.5
            //                 }
            //             ],
            //             image: {
            //                 name: "",
            //                 source: "",
            //                 sourceBig: ""
            //             }
            //         }
            // },


            // {
            //     "id" : "9cxam3do38djwqo6bxq",
            //     "type" : "priceOffer",
            //     "usecase" : "takeAway",
            //     "active" : true,
            //     "name" : "Schnitzeltag",
            //     "timeText" : "Jeden Mittwoch und Freitag",
            //     "offerText" : "große Auswahl an Schnitzelgerichten",
            //     "offerPrice" : 7.5,
            //     "days" : {
            //         "1" : true,
            //         "2" : true,
            //         "3" : true,
            //         "4" : true,
            //         "5" : true,
            //         "6" : true,
            //         "7" : true
            //     },
            //     "items" : [
            //         {
            //             "name" : "Putenschnitzel",
            //             "id" : "9tqn2g3i9hmjwjajk2f",
            //             "vol" : ""
            //         },
            //         {
            //             "name" : "Schnitzel Wiener Art",
            //             "id" : "oiua6uaa2pgjwjakiih",
            //             "vol" : ""
            //         },
            //         {
            //             "name" : "Rahmschnitzel",
            //             "id" : "1m8xci2m2okjwjal4ty",
            //             "vol" : ""
            //         },
            //         {
            //             "name" : "Jägerschnitzel",
            //             "id" : "mi1rxixvsnsjwjakutw",
            //             "vol" : ""
            //         },
            //         {
            //             "name" : "Gorgonzolaschnitzel",
            //             "id" : "tk99jt7i3tjwjalhzm",
            //             "vol" : ""
            //         },
            //         {
            //             "name" : "Schnitzel Hawaii",
            //             "id" : "hjjivei12qbjwjalwlq",
            //             "vol" : ""
            //         },
            //         {
            //             "name" : "Bologneseschnitzel",
            //             "id" : "bvawzwgxehojwjamh3j",
            //             "vol" : ""
            //         }
            //     ]
            // }
        ]
        // }
    },
    actions: {},
    mutations: {

        offers(state, payload) {
            state.offers.splice(0, state.offers.length);
            for (let offer of payload) {
                state.offers.push(offer);
            }
        },

        offerPromotions(state, payload) {
            state.offerPromotions.splice(0, state.offerPromotions.length);
            for (let promo of payload) {
                state.offerPromotions.push(promo);
            }
        }


    },
    getters: {
        offers: (state) => {
            return state.offers;
        },

        offerPromotions: (state) => {
            return state.offerPromotions;
        },

        getOfferById: (state) => (id) => {
            return state.offers.find(offer => offer.id === id)
        },

        getOfferByItemId: (state) => (itemId) => {
            let result = {
                offer: {},
                item: {} //offeredItem
            };
            for (let offer of state.offers) {
                if (offer.type === 'priceOffer' || offer.type === 'discountOffer') {
                    for (let offeredItem of offer.items) {
                        if (offeredItem.id === itemId) {
                            result.offer = offer;
                            result.item = offeredItem;
                            return result;
                        }
                    }
                }
            }
            return null;
        },
    }
};